import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Container,
  TextField,
  Button,
  Stack,
} from "@mui/material";

import "../assets/css/ba-style.css";


const ResetPassword = () => {
  return (
    <div>
      <Container maxWidth="sm">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} lg={12}>
              <Card sx={{ minWidth: 275 }} className="ba-login-card-warpper">
                <CardContent className="ba-login-content d-flex flex-column align-items-center">
                  <Typography className="ba-login-span">
                    Reset Password
                  </Typography>
                  <Typography>
                    <form>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        lg={12}
                        className="ba-forgot-textField"
                      >
                        <TextField
                          required
                          id="standard-required"
                          label="Code"
                          variant="standard"
                          type="text"
                          className="ba-forgot-textField"
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        lg={12}
                        className="ba-forgot-textField"
                      >
                        <TextField
                          required
                          id="standard-required"
                          label="New password"
                          variant="standard"
                          type="password"
                          className="ba-forgot-textField"
                        />
                      </Grid>

                      <Stack
                        spacing={2}
                        direction="row"
                        className="ba-login-btn-wrapper"
                      >
                        <Button
                          variant="contained"
                          type="submit"
                          className="ba-login-btn"
                        >
                          Reset and login
                        </Button>
                      </Stack>
                    </form>
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </div>
  );
};

export default ResetPassword;
